<template>
  <div>
    <div id="chart">
      <apexchart type="bar" height="350" :options="chartOptions" :series="model"></apexchart>
    </div>
  </div>
</template>

<script>
export default {
  name: "BillingMonthChartBar",
  components: {},
  props: {
    model: Array,
    dataType: Number,
    dates: Array,
    chartOptions: Object,
    counter: Number
  },
  data: function() {
    return {
      series: []
    };
  }
};
</script>